import React from 'react';
import './Footer.css'
const Footer = () => {
    return (
        <div className='footer'>
            <p>Copy Right &copy; 2021 || Design by Jakaria </p>
        </div>
    );
};

export default Footer;